<script>
    // import rpcjs from 'rpcjs';
    import TwoInOnebutton from '../../../reusableitems/TwoInOnebutton.svelte';
    // const { title } = rpcjs.props;
    // title.set('Demo');
    const main = 'main';
</script>

<div class={main}>
    <div class="demo">
        <!-- svelte-ignore a11y-media-has-caption -->
        <video width="100%" height="100%" controls autoplay muted>
            <source src="https://static.opus.ai/demo.mp4" type="video/mp4" />
        </video>
        <div
            role="presentation"
            class="cancelBtn"
            on:click
        >
            <p>Close</p>
        </div>
    </div>
    <div class="btn">
        <TwoInOnebutton />
    </div>
</div>

<style>
    .main {
        position: relative;
        background-color: black;
        width: 100%;
        height: 100%;
    }
    p {
        margin: 0;
    }
    .logo {
        width: 16.481vh;
        height: 6.852vh;
        background-color: black;
        border-radius: 0 0.926vh 0.926vh 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;
        padding-top: 4vh;
        padding-left: 3vh;
    }
    .demo {
        position: absolute;
        width: 107.365vh;
        height: 62.315vh;
        left: 27.741vh;
        top: 15.407vh;
    }
    .cancelBtn {
        position: absolute;
        font-family: "Orbitron";
        color: white;
        font-size: 1.852vh;
        font-weight: 900;
        top: -4vh;
        right: 0;
        cursor: pointer;
    }
    .btn {
        position: absolute;
        left: 70.852vh;
        bottom: 16.648vh;
    }
</style>
